import axios from 'axios';
import Cookies from 'js-cookie';

import { isLocalhostHostname } from '@/lib/env';

export function getBrowserApiBaseURL() {
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_API_BASE_URL ?? '';
  }

  const hostname = window.location.hostname;
  const isLocalhost = isLocalhostHostname(hostname);

  return isLocalhost ? '/api/' : (process.env.NEXT_PUBLIC_API_BASE_URL ?? '/api/');
}

function getBaseURL() {
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_API_BASE_URL;
  }

  return getBrowserApiBaseURL();
}

const api = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// make sure axios reads csrftoken cookie and sends X-CSRFToken header
api.defaults.xsrfCookieName = 'csrftoken';
api.defaults.xsrfHeaderName = 'X-CSRFToken';
api.defaults.withXSRFToken = true;

// Update token dynamically before every request
// The interceptor ensures the latest CSRF token is always used,
// even if it changes after the initial page load
api.interceptors.request.use(async (config) => {
  // only on client
  if (typeof window !== 'undefined') {
    const token = Cookies.get('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
  }

  // Enforce trailing slash on URLs
  if (config.url) {
    // Split out query string if present
    const [path, query] = config.url.split('?');

    // Ensure path ends with a slash
    const normalizedPath = path.endsWith('/') ? path : `${path}/`;
    const configUrl = query ? `${normalizedPath}?${query}` : normalizedPath;

    config.url = configUrl;
  }

  return config;
});

export default api;
